import React, { memo, useMemo, useCallback } from 'react';
import { createUseStyles, Switch } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'SwitchFormatter');

const SwitchFormatter = memo(({ data, onChange }) => {
    const classes = useStyles();
    const isActive = useMemo(() => {
        if (data?.nameField === -2) return true;
        return false;
    }, [data?.nameField]);

    const handleOnChange = useCallback(() => {
        // We set value create as newOne
        // Backend when receive a -2 knows that has to create that value as a new one
        const newValue = data?.nameField !== -2 ? -2 : -1;
        onChange(data.index, newValue);
    }, [data, onChange]);

    return (
        <div className={classes.switchFormatter}>
            <Switch checked={isActive} onChange={handleOnChange} />
        </div>
    );
});

export default SwitchFormatter;
